/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Link field representation.
 */
export interface ClaimsSchemaFieldLinkValue {
    /** Determine whether the field values should be an array. */
    isArray?: boolean;
    /** The type of the link. */
    linkType?: Truvity.ClaimsSchemaFieldLinkValueLinkType;
    /** Field name. */
    name: string;
    notEmpty?: boolean;
    /** The human-readable name of the field can be used to display the field in the UI. */
    title?: string;
}
